import * as tslib_1 from "tslib";
import * as Logger from 'js-logger';
import { VideoTagPlayerComponent } from '@app/player/video-tag-player.component';
var logger = Logger.get('video-tag-player');
var BLACK_POSTER = 'data:image/png;base64,'
    + 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAADElEQVR42mNgYGAAAAAEAAHI6uv5AAAAAElFTkSuQmCC';
var VideoPlayerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(VideoPlayerComponent, _super);
    function VideoPlayerComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.poster = BLACK_POSTER;
        return _this;
    }
    return VideoPlayerComponent;
}(VideoTagPlayerComponent));
export { VideoPlayerComponent };
